/**
 * @file ReportSection.tsx
 * @brief Grid primitives helpers for report KPI rows + titled table bands.
 *
 * @author DES
 * @date 29-07-2026
 */

import type { ReactNode } from "react";
import {
  GridBand,
  GridCell,
  GridCells,
} from "@/features/analytics/components/GridBlock";
import { cn } from "@/shared/theme/cn";

export function ReportKpiRow({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <GridCells className={cn("grid-cols-1 sm:grid-cols-2 xl:grid-cols-4", className)}>
      {children}
    </GridCells>
  );
}

export function ReportKpiCell({ children }: { children: ReactNode }) {
  return <GridCell padded={false}>{children}</GridCell>;
}

export function ReportSectionHeader({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <GridBand>
      <h3 className="text-sm font-semibold tracking-tight">{title}</h3>
      {description ? (
        <p className="mt-1 text-xs text-muted-foreground">{description}</p>
      ) : null}
    </GridBand>
  );
}

export function ReportTableCell({ children }: { children: ReactNode }) {
  return <GridCell padded={false}>{children}</GridCell>;
}
